module.exports = __webpack_public_path__ + "img/flavors.4f3a4207.jpg";